import { PageHero } from "@/components/Reveal";
import { EMAIL, ADDRESS_1, ADDRESS_2 } from "@/lib/site";

const TEXTS = {
  aviso: {
    eyebrow: "Aviso legal",
    lines: ["Aviso", "legal."],
    body: [
      "Titular: Karina Méndez — Studio de Belleza Karina Méndez.",
      `Dirección: ${ADDRESS_1}, ${ADDRESS_2}.`,
      `Contacto: ${EMAIL} · +34 691 536 518.`,
      "Este sitio web tiene fines informativos sobre los servicios de estética y micropigmentación ofrecidos por el studio. El acceso y uso del sitio implica la aceptación de estas condiciones.",
      "Los contenidos, textos, marca e imágenes de este sitio son titularidad de Karina Méndez y no pueden reproducirse sin autorización.",
    ],
  },
  privacidad: {
    eyebrow: "Privacidad",
    lines: ["Política de", "privacidad."],
    body: [
      "Los datos facilitados a través de los formularios de este sitio (nombre, teléfono, correo electrónico y mensaje) se utilizan únicamente para responder a tu solicitud, gestionar la lista de espera de la Academia Karina Méndez y contactarte en relación con nuestros servicios.",
      "No cedemos tus datos a terceros ni los utilizamos con fines distintos a los descritos. Puedes ejercer tus derechos de acceso, rectificación, supresión y oposición escribiendo a " + EMAIL + ".",
      "Responsable del tratamiento: Karina Méndez — Studio de Belleza Karina Méndez, " + ADDRESS_1 + ", " + ADDRESS_2 + ".",
    ],
  },
};

const Legal = ({ type }) => {
  const t = TEXTS[type] || TEXTS.aviso;
  return (
    <div data-testid={`legal-${type}-page`}>
      <PageHero eyebrow={t.eyebrow} lines={t.lines} />
      <section className="bg-cream px-6 sm:px-12 lg:px-20 pb-24 max-w-3xl space-y-6">
        {t.body.map((p, i) => (
          <p key={i} className="text-ink/75 leading-relaxed">
            {p}
          </p>
        ))}
      </section>
    </div>
  );
};

export default Legal;
